module.exports = __webpack_public_path__ + "img/225.8ca85f18.png";